import { NOT_IMPLEMENTED } from 'constants/portfolioStatuses';

export const adaptRemoveLinkPortfolio = (data, expiredClientName = '') => {
    if (data === null || data === undefined) return null;

    return data.map(object => {
        if (object.Status.value === NOT_IMPLEMENTED) {
            object.Name.disabled = true;
        }
        if (object?.AccountHolder?.length > 1) {
            object.AccountHolder = object.AccountHolder?.map(holder => {
                if (holder?.trim().toLowerCase() === expiredClientName?.toLowerCase()) {
                    return `${holder} †`;
                }

                return holder;
            });
        }

        return object;
    });
};
